import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PreFooterCta.css';

export const PreFooterCta: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="pre-footer-cta-wrapper">
      <section className="pre-footer-cta">
        <h2 className="pre-footer-cta-title">Ready to transform your data?</h2>
        <p className="pre-footer-cta-desc">
          Join thousands of data-driven professionals who are creating beautiful visualizations in minutes.
        </p>
        <button 
          className="pre-footer-cta-button"
          onClick={() => navigate('/signup')}
          type="button"
        >
          Start for free
        </button>
      </section>
    </div>
  );
};
